<!--
 * @Autor:
 * @Date: 2023-07-30 10:35:35
 * @LastEditTime: 2024-07-09 21:50:20
 * @Description:
 * @FilePath: \register\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  min-height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue